import { Component } from '@angular/core';
@Component({
    selector: 'app-root',
    templateUrl: './app.html',
})
export class AppComponent { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/app.component.ts